/**
 * Import all reducers into a single object.
 */

import { combineReducers } from 'redux';
import { AppStateReducer } from './AppStateReducer';

import userReducer from '../redux/modules/user/reducer';
import cardReducer from '../redux/modules/card/reducer';
import vehicleReducer from '../redux/modules/vehicle/reducer';
import accountReducer from '../redux/modules/account/reducer';
import messageReducer from '../redux/modules/message/reducer';
import companyReducer from '../redux/modules/company/reducer';
import cctransactionReducer from '../redux/modules/cctransaction/reducer';
import loginReducer from '../redux/modules/login/reducer';
import policeReducer from '../redux/modules/police/reducer';
import storagelotReducer from '../redux/modules/storagelot/reducer';
import companypropertyReducer from '../redux/modules/companyproperty/reducer';
import vinReducer from '../redux/modules/vin/reducer';
import towjobReducer from '../redux/modules/towjob/reducer';
import faxReducer from '../redux/modules/fax/reducer';
import emailReducer from '../redux/modules/email/reducer';
import pdfReducer from '../redux/modules/pdf/reducer';
import policenoticeReducer from '../redux/modules/policenotice/reducer';
import dispatchsheetReducer from  '../redux/modules/dispatchsheet/reducer';
import towcompanydriverReducer from  '../redux/modules/towcompanydriver/reducer';
import towcompanytruckReducer from  '../redux/modules/towcompanytruck/reducer';
import propertyvehicleReducer from '../redux/modules/propertyvehicle/reducer';

import parkingincidentReducer from '../redux/modules/parkingincident/reducer';

// Combine reducers
const reducers = combineReducers(Object.assign({}, {
        appState: AppStateReducer,
        user:userReducer,
        card:cardReducer,
        vehicle:vehicleReducer,
        account:accountReducer,
        message:messageReducer,
        company:companyReducer,
        police:policeReducer,
        cctransaction:cctransactionReducer,
        login:loginReducer,
        storagelot:storagelotReducer,
        companyproperty:companypropertyReducer,
        vin:vinReducer,
        towjob:towjobReducer,
        fax:faxReducer,
        email:emailReducer,
        pdf:pdfReducer,
        policenotice:policenoticeReducer,
        dispatchsheet:dispatchsheetReducer,
        towcompanydriver:towcompanydriverReducer,
        towcompanytruck:towcompanytruckReducer,
        propertyvehicle:propertyvehicleReducer,
        parkingincident:parkingincidentReducer,
    }
));

export default reducers;
